/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
// useGLTF to load GLTF model into the canvas
import { useAnimations, useGLTF } from '@react-three/drei'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { useLoader } from '@react-three/fiber'
import { MeshStandardMaterial } from 'three';

const MODELS_BASEPATH = `${process.env.PUBLIC_URL}/models`
const TEXTURE_BASEPATH = `../assets/img`



export default function JokerMoto(props) {

  const group = useRef()
  const { nodes, materials } = useGLTF(`${MODELS_BASEPATH}/joker_moto.gltf`)



  const red = new MeshStandardMaterial({
    color: 0xAC2431,
  })
  const black = new MeshStandardMaterial({
    color: 0x000000,
  })
  const gray = new MeshStandardMaterial({
    color: 0x1F161E,
  })
  const orange = new MeshStandardMaterial({
    color: 0xFF5F12,
  })
  const purple = new MeshStandardMaterial({
    color: 0x482A54,
  })
  const orangeLight = new MeshStandardMaterial({
    color: 0xE97452,
  })
  const lightGray = new MeshStandardMaterial({
    color: 0x4B464A,
  })


  return (
    <group {...props} dispose={null}>
      <group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.archidavanti001.geometry}
          material={lightGray}
          position={[0.829, 0.572, 0.069]}
          rotation={[0.635, -0.22, -2.655]}
          scale={[-0.951, -0.949, -0.828]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.archidavanti1001.geometry}
          material={lightGray}
          position={[0.829, 0.572, -0.07]}
          rotation={[-0.635, 0.22, 0.486]}
          scale={[0.951, 0.949, 0.828]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['bulloni_fronte-basso001'].geometry}
          material={gray}
          position={[0.877, -0.257, 0.026]}
          rotation={[-0.685, 0.915, -1.427]}
          scale={[-0.165, -1.361, -0.165]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['bulloni_lato-basso002'].geometry}
          material={gray}
          position={[0.038, -0.403, -0.683]}
          rotation={[-2.287, 0.28, -0.111]}
          scale={[-0.136, -0.122, -0.136]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['bulloni_lato-basso003'].geometry}
          material={gray}
          position={[0.038, -0.403, 0.683]}
          rotation={[2.287, -0.28, 3.03]}
          scale={[0.136, 0.122, 0.136]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['bulloni_lato-sopra001'].geometry}
          material={materials['bulloni.001']}
          position={[0.568, 0.529, -0.412]}
          rotation={[-1.564, 0.003, 0]}
          scale={[-0.159, -1.103, -0.159]}
        />
        <group position={[-1.738, -0.063, 0.005]} rotation={[Math.PI / 2, -1.15, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.CERCHIONE001.geometry}
            material={black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.CERCHIONE001_1.geometry}
            material={red}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['collegamento_corpo-fronte001'].geometry}
          material={lightGray}
          position={[0.79, 0.785, 0]}
          rotation={[0, 0, -2.254]}
          scale={0.054}
        />
        <group position={[0, 0, 0]} rotation={[0, 0, -0.003]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh002.geometry}
            material={black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh002_1.geometry}
            material={lightGray}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh002_2.geometry}
            material={purple}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh002_3.geometry}
            material={gray}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.j_cavo_davanti001.geometry}
          material={red}
          position={[1.102, 0.751, 0.166]}
          rotation={[0, 0, -0.003]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.guscione001.geometry}
          material={red}
          position={[0.065, 0.566, -0.002]}
          rotation={[0, 0, 0.121]}
          scale={[1.211, 1.259, 1.022]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lamieraruota001.geometry}
          material={black}
          position={[-1.654, -0.063, 0.005]}
          rotation={[Math.PI / 2, -0.003, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.robini_carburante001.geometry}
          material={red}
          position={[0.298, 0.814, -0.152]}
          rotation={[-0.366, 0.039, 0.045]}
          scale={[0.042, 0.027, 0.042]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.robino_cavo001.geometry}
          material={purple}
          position={[2.083, -0.127, -0.273]}
          rotation={[0, 0, 1.567]}
          scale={[1.156, 0.485, 1.156]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubi0001.geometry}
          material={lightGray}
          position={[-1.612, 0.536, 0]}
          rotation={[0, 0, -0.003]}
          scale={1.033}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubi4001.geometry}
          material={lightGray}
          position={[-1.435, 0.061, 0]}
          rotation={[0, 0, -0.003]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubi5001.geometry}
          material={lightGray}
          position={[-1.676, 0.028, -0.419]}
          rotation={[0, 0, -0.003]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubii6001.geometry}
          material={lightGray}
          position={[-1.105, -0.382, -0.451]}
          rotation={[0.053, -0.119, -1.151]}
          scale={[-0.039, -0.411, -0.039]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubii7001.geometry}
          material={lightGray}
          position={[-1.105, -0.382, 0.451]}
          rotation={[-0.053, 0.119, 1.991]}
          scale={[0.039, 0.411, 0.039]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubo1001.geometry}
          material={lightGray}
          position={[-1.285, 0.281, 0.653]}
          rotation={[-3.079, -0.101, -1.015]}
          scale={[-0.069, -1, -0.069]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.scappatubo2001.geometry}
          material={lightGray}
          position={[-1.288, 0.282, -0.629]}
          rotation={[3.079, 0.101, 2.127]}
          scale={[0.069, 1, 0.069]}
        />
        <group
          position={[2.195, 0.001, -0.001]}
          rotation={[0, 0, 0.926]}
          scale={[0.378, 0.378, 0.35]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008.geometry}
            material={black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_1.geometry}
            material={purple}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_2.geometry}
            material={black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_3.geometry}
            material={red}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_4.geometry}
            material={black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_5.geometry}
            material={purple}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_6.geometry}
            material={orangeLight}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_7.geometry}
            material={materials['grigiocruscotto.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_8.geometry}
            material={materials['contachilo.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_9.geometry}
            material={materials['screen.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_10.geometry}
            material={lightGray}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_11.geometry}
            material={materials['astegiialle.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_12.geometry}
            material={materials['verd.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_13.geometry}
            material={materials['schermo.002']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_14.geometry}
            material={materials['lampadagross.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_15.geometry}
            material={materials['lampadagiall.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_16.geometry}
            material={materials['lampadapicc.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle008_17.geometry}
            material={materials['tastoverde.001']}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.tubettodavanti001.geometry}
          material={lightGray}
          position={[0.859, 0.548, 0.145]}
          rotation={[0, 0, 1.876]}
          scale={-0.247}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.tubettodavantii001.geometry}
          material={lightGray}
          position={[0.859, 0.548, -0.146]}
          rotation={[0, 0, -1.266]}
          scale={0.247}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.tubosedile001.geometry}
          material={lightGray}
          position={[0.794, 0.58, -0.181]}
          rotation={[0, 0, -0.003]}
        />
      </group>
    </group>
  )
}

useGLTF.preload(`${MODELS_BASEPATH}/joker_moto.gltf`)